import { useScreenType } from 'hooks/useScreenType'
import React, { useState } from 'react'
import style from './style.module.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';
import 'react-lazy-load-image-component/src/effects/blur.css';
import menu from '../../../assets/menu.png';
//import MobileSideMenu from './MobileSideMenu';
import Sidebar from "react-sidebar";
import stores from 'assets/stores.png';
import loginicon from "assets/user.png";
//import searchicon from "assets/search.png";
import SearchField from './SearchField';
import whatsapp from "../../../assets/whatsapp.svg"
import facebook from "../../../assets/facebook.svg"
import ReactWhatsapp from 'react-whatsapp';
//import { HiMenuAlt3 } from "react-icons/hi";
import bigappslogo from '../../../assets/bigappslogo.png'
import apple from '../../../assets/apple.png'
import android from '../../../assets/android.png'
import { IoMenu } from "react-icons/io5";
import { IoPersonOutline } from "react-icons/io5";
import { IoGridOutline } from "react-icons/io5";

const styles = {
    sidebar: {
        backgroundColor: 'rgb(80, 80, 80)',
        color: '#FFFFFF',
        zIndex: 2,
        position: "absolute",
        top: 0,
        bottom: 0,
        width: '60%',
        transition: "transform left .3s ease-out",
        WebkitTransition: "-webkit-transform .3s ease-out",
        willChange: "transform",
        overflowY: "auto",
        borderRadius: '15px 0 0 15px',
    },
    content: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        transition: "left .3s ease-out, right .3s ease-out"
    },
    overlay: {
        zIndex: 1,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0,
        visibility: "hidden",
        transition: "opacity .3s ease-out, visibility .3s ease-out",
        backgroundColor: "rgba(0,0,0,.35)"
    },
    dragHandle: {
        zIndex: 1,
        position: "fixed",
        top: 0,
        bottom: 0
    }
};

const menuBtns = ['MyBudget', 'History', 'About', 'TablePapiano', 'ShopMenu'];

const menuMobileBtns = ['Accessibility', 'RetPolicy', 'PPolicy', 'Terms', 'About', 'Contacts', 'MyBudget', 'History', 'TablePapiano', 'ShopMenu'];

const menuMobileBtnsFalafelZikhron = ['Accessibility', 'RetPolicy', 'PPolicy', 'Terms', 'About', 'Contacts','History', 'ShopMenu'];

const TopMenuLayout = ({ activeTopMenu, setActiveTopMenu, thisCart, shop,
                        closeStore, isPackItemUpdating, isCartItemUpdating,
                        userParams, userToken, shopsData, userId, setSearchValue, 
                        basketIsOpen, closeBasket, toggleBasket, fastToggleBasket, 
                        shopData, my_env, __mobx_sync_versions__, dir }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const { t } = useTranslation();

    const menuIconStyles = {
        display: 'inline-block',
        position: 'absolute',
        top: '21px',
        [dir ==='rtl'?'right':'left']: '20px'
    }
    
    const renderSidebarContent = (pageName) => {
        const gotoPage = (item) => {
            if(basketIsOpen) toggleBasket();
            setMenuIsOpen(false);
            setActiveTopMenu(item);
        }

        const gotoStoresPage = () => {
            if(isPackItemUpdating || isCartItemUpdating){
              thisCart.cartItemList.pop();
            }       
            closeStore();
        }

        const gotoRegistrationPage = () => {
            setMenuIsOpen(false);
            //if(!userToken) 
            setSearchValue('', true);
            return /*!userToken ? */ setActiveTopMenu("Registration") /*: null*/;
        }
        return(
            <div className={style.SidebarContent}>
                <div className={style.SocialIcons}>
                    
                    {
                      shop.linkFacebook
                      ?
                        <img alt="" src={facebook} width="40px" 
                             onClick={()=> window.open(shop.linkFacebook, "_blank")}/>
                      :
                        ''
                    }
                    {
                      shop.phoneWhatsapp
                      ?
                        <ReactWhatsapp style={{backgroundColor: 'transparent', border: 'unset',
                                               outline: 'none', width: "50px", margin: '0 10px 0 10px', padding: 0,
                                               }}
                                       number={shop.phoneWhatsapp} message=''>
                            <img alt="" src={whatsapp} width="78%" height="100%"  />
                        </ReactWhatsapp>
                      :
                        ''
                    }
                </div>
                <div className='wrappIcons' style={{display: 'flex', justifyContent: 'space-between', fontSize: '10px', padding: '5px 0 15px 0', borderBottom: '2px solid #808080'}}>
                    <div className={style.DivLogin} style={{alignItems: 'center', display: 'flex', justifyContent: 'center', cursor: 'default'}}>
                        <div
                            className={style.LogIconDiv}
                            onClick={gotoRegistrationPage}
                            title={userToken ?  t('LoggedIn') : t('LogIn')}
                            style={{marginRight: '5px', marginLef: '5px', cursor: /*userToken ? 'default' : */'pointer'}}
                        >
                            <IoPersonOutline className={style.LogIconDivIcon}/>
                        </div>

                        <div 
                            className={style.LoginText} 
                            onClick={gotoRegistrationPage}
                            style={{marginRight: '5px', marginLeft: '5px', cursor: 'pointer'}}
                        >
                            {userToken ? (
                            <>
                                <div>{t('Hello')},</div>
                                <div>{userParams.name}</div>
                            </>
                            ) : (
                            <>
                                <div>{t('Hi_guest')}</div>
                                <div className={style.LoginHere}>{t('LogIn')}</div>
                            </>
                            )}
                        </div>
                    </div>

                    {
                        (shopsData && shopsData.shops?.length) ?
                            <div className='allStores' style={{marginLeft: '5px', marginRight: '5px'}}>
                                <div className={style.StoresImg} onClick={gotoStoresPage}>
                                    <IoGridOutline className={style.StoresImgIcon}/>
                                </div>
                            </div> : null
                    }
                </div>

                <div className='item-list' style={{display: 'flex', flexDirection: 'column-reverse'}}>
                {
                    (my_env.url.indexOf("falafelzikhron") >= 0 ? menuMobileBtns /*menuMobileBtnsFalafelZikhron*/ : menuMobileBtns).map((item, idx) => {
                        return(
                            item === 'TablePapiano' 
                            ?
                                my_env.url.indexOf("papiano") >= 0
                                ?
                                    <div key={idx} className={style.mobileMenubtn}>
                                        <a target='_blank' rel="noreferrer" href="https://ontopo.co.il/papiano?source=homepage">{t(item)}</a>
                                    </div>
                                :
                                    null
                            :
                                ((item === 'History' && userToken === null) || (item === 'Accessibility' && (shopData == null || !shopData['accessibilityMessage'])) || (item === 'MyBudget' && (userToken === null || shopData?.shop?.hasBudget != 1)))
                                ?
                                    null
                                :
                                    <div onClick={() => {setSearchValue('', true); gotoPage(item)}} key={idx} className={style.mobileMenubtn}>
                                        {t(item)}
                                    </div>
                        )
                    })
                }
                </div>
                <div className={style.BigappsLogo} onClick={()=> window.open("https://my-shop.co.il/", "_blank")}>
                    <LazyLoadImage
                    src={bigappslogo}
                    alt="my-shop"
                    width="100%"
                    />
                </div>
                <div className={style.MobileBtns}>
                {
                    shop.linkGoogle
                    ?
                    <LazyLoadImage
                        src={android}
                        alt="android"
                        width="100%"
                        onClick={()=> window.open(shop.linkGoogle, "_blank")}
                    />
                    :
                    ''
                }
                {
                    shop.linkApple
                    ?
                    <LazyLoadImage
                        src={apple}
                        alt="apple"
                        width="100%"
                        onClick={()=> window.open(shop.linkApple, "_blank")}
                    />
                    :
                    ''
                }
                </div>
                <div className={style.MobVersionDiv}>
                    v{__mobx_sync_versions__.__mobx_sync_this__}
                </div>
            </div>
        )
    }
    const isfullscreen = useScreenType() === 'fullscreen';
    return (
        <div className={style.Container}>
        {
            !isfullscreen
            ?
            
                <div id="" className={style.AppTopMenu}>
                    <SearchField />
                    {
                        menuBtns.map((item, index) => {
                            return (
                                <React.Fragment key={index}>
                                    {
                                        item === 'TablePapiano' 
                                        ?
                                            my_env.url.indexOf("papiano") >= 0
                                            ?
                                                <div key={`ind_${index}`}>
                                                    <div className={style.menubtn}>
                                                        <a target='_blank' rel="noreferrer" href="https://ontopo.co.il/papiano?source=homepage">{t(item)}</a>
                                                    </div>
                                                </div>
                                            :
                                                null
                                            
                                        :
                                            (item === 'History' && userToken === null) || (item === 'MyBudget' && (userToken === null || shopData?.shop?.hasBudget != 1))
                                            ?
                                                null
                                            :
                                                <div key={`ind_${index}`}>
                                                    <div className={activeTopMenu === item ?
                                                        `${style.menubtn} ${style.menubtnActive}` :
                                                        style.menubtn} onClick={() => {setSearchValue('', true); setActiveTopMenu(item)}} >{t(item)}</div>
                                                </div>
                                    }
                                </React.Fragment>
                            )
                        })
                    }
                </div>
            :
                <>
                    <Sidebar
                        sidebar={renderSidebarContent()}
                        open={menuIsOpen}
                        transitions={true}
                        onSetOpen={setMenuIsOpen}
                        styles={styles}
                        pullRight={true}
                        touch={true}
                    >
                    
                        <div style={menuIconStyles} onClick={() => setMenuIsOpen(true)}>
                            <IoMenu className={style.burgerIcon}/>
                        </div>
                    </Sidebar>

                    <div style={{
                        position: 'absolute', 
                        top: '67px', 
                        [dir==='rtl' ? 'right': 'left']: (dir==='rtl'? '14px' : '25px')}}>
                        <SearchField />
                    </div>
                </>
        }

        </div>
    )
}

export default TopMenuLayout
